export default __webpack_public_path__ + "static/media/sopSaveIcon_disabled.0f5d39c7.svg";